// Resize a stored completion array to match the routine's current task count.
// Per plan/02 §Write strategy: a parent adding a task between writes means
// the stored array is shorter; removing means it's longer. Pad with `false`
// (the fresh task isn't done yet) and truncate at the right index.
//
// Caveat: the boolean array is positional — index 0 corresponds to the
// task at sortIndex 0 at write time. If a parent reorders tasks without
// changing the count, the booleans line up with the *old* order. Plan/02
// accepts this for v1; revisit by keying progress per-taskId when the
// schema bumps.
export function padCompleted(stored: readonly boolean[], length: number): boolean[] {
  const result: boolean[] = stored.slice(0, length);
  while (result.length < length) result.push(false);
  return result;
}
